/* eslint-disable no-alert */
import React, { useContext, useState } from 'react'
import useQuery from 'hooks/useQuery'
import { Roles } from 'utils/enums'
import ClientsSection from 'components/admin/Tables/Clients'
import TranslatorsSection from 'components/admin/Tables/Translators'
import MediatorsSection from 'components/admin/Tables/Mediators'
import AccountsSection from 'components/admin/Tables/Accounts'
import TableButton from 'components/common/Buttons/TableButton'
import { useNavigate, useParams } from 'react-router-dom'
import PasswordPrompt from 'components/Prompts/PasswordPrompt'
import RoleTabs from 'components/admin/Tabs'
import { Button } from '@mui/material'

const AccountsManagement = () => {
  const navigate = useNavigate()
  const params = useParams()

  const [roleObject, setRoleObject] = useState(
    rolesToShow.find(({ mainPath }) => params.role === mainPath)
      || rolesToShow[0],
  )

  const { makeRequest: deleteUser } = useQuery({
    isControlled: true,
    defaultMethod: 'delete',
    toastOptions: {
      showFeedbackMessage: true,
      resultMessageSuccess: 'Usuario borrado',
      resultMessageError: { 401: 'Contraseña incorrecta' },
    },
    disableAutoLogoutOn401: true,
  })

  const { makeRequest: deleteCalls } = useQuery({
    isControlled: true,
    defaultMethod: 'delete',
  })

  const [deletePrompt, setDeletePrompt] = useState(null)
  const [deleteCallsDate, setDeleteCallsDate] = useState('')

  const deleteCallsHandler = () => {
    deleteCalls({
      endpoint: `/admins/calls/${encodeURIComponent(deleteCallsDate)}`,
    })
  }

  const getColumnForDeleting = (rolePath) => ({
    Header: 'Borrar Usuario',
    accessor: ({ id }) => (
      <TableButton
        clickHandler={() => {
          setDeletePrompt({
            title: 'Ingrese su contraseña',
            onOk: async (authPassword) => {
              await deleteUser({
                endpoint: `/admins/${rolePath}/${id}`,
                body: { authPassword },
              })
              navigate(`/admins/deleted/${rolePath}`)
            },
          })
        }}
      >
        Borrar
      </TableButton>
    ),
  })

  let SelectedSection
  if (roleObject.role === Roles.Mediator.role) {
    SelectedSection = (
      <MediatorsSection
        getColumnForDeleting={getColumnForDeleting}
        disableAutoScroll
      />
    )
  } else if (roleObject.role === Roles.Client.role) {
    SelectedSection = (
      <ClientsSection
        endpoint='/admins/clients'
        getColumnForDeleting={getColumnForDeleting}
        disableAutoScroll
      />
    )
  } else if (roleObject.role === Roles.Translator.role) {
    SelectedSection = (
      <TranslatorsSection
        endpoint='/admins/translators'
        getColumnForDeleting={getColumnForDeleting}
        disableAutoScroll
      />
    )
  } else if (roleObject.role === Roles.Account.role) {
    SelectedSection = (
      <AccountsSection
        endpoint='/admins/accounts'
        getColumnForDeleting={getColumnForDeleting}
        disableAutoScroll
      />
    )
  }
  return (
    <div className='flex flex-col'>
      <div>
        <input
          className='mr-4'
          type='date'
          value={deleteCallsDate}
          onChange={(e) => {
            setDeleteCallsDate(e.target.value)
          }}
        />
        <Button onClick={deleteCallsHandler} disabled={!deleteCallsDate}>
          borrar llamadas previas
        </Button>
      </div>
      <RoleTabs options={rolesToShow} tab={roleObject} setTab={setRoleObject}>
        {SelectedSection}
      </RoleTabs>
      {deletePrompt && (
        <PasswordPrompt prompt={deletePrompt} setShowPrompt={setDeletePrompt} />
      )}
    </div>
  )
}

const rolesToShow = [
  Roles.Translator,
  Roles.Client,
  Roles.Mediator,
  Roles.Account,
]

export default AccountsManagement
